// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LArZx","top":"styles_top__3vNrs","left":"styles_left__1ZYQn","description":"styles_description__292Zf"};